import * as DebinActions from './actions'
import { DebinServices } from 'services'
import { ThunkDispatchType } from 'store'
import { showDrawer } from 'store/drawer/actions'
import { Drawers, OperationType } from 'store/drawer/types'

export const getRecurrences = () => async (dispatch: ThunkDispatchType) => {
  try {
    dispatch(DebinActions.getRecurrencesPending())
    const response = await DebinServices.getRecurrences()

    if (response.status !== 200) {
      throw response?.data.data
    }
    dispatch(DebinActions.getRecurrencesFulfilled(response.data.data))
  } catch (error) {
    dispatch(DebinActions.getRecurrencesRejected())
  }
}

export const confirmRecurrence =
  (recurrenceId: number, isAccepted: boolean) =>
    async (dispatch: ThunkDispatchType) => {
      try {
        dispatch(DebinActions.confirmRecurrencePending())
        const response = await DebinServices.confirmRecurrence({
          recurrenceId,
          isAccepted
        })

        if (response.status !== 200) {
          throw response?.data.data
        }
        dispatch(
          showDrawer(Drawers.DEBIN_OPERATION_SUCCESS, {
            debinData: {
              operationType: OperationType.DEBIN_CONFIRMATION,
              isAccepted
            }
          })
        )
        dispatch(DebinActions.confirmRecurrenceFulfilled(response.data.data))
        dispatch(getRecurrences())
      } catch (error) {
        dispatch(showDrawer(Drawers.DEBIN_OPERATION_ERROR, {
          debinData: {
            operationType: OperationType.DEBIN_CONFIRMATION,
            isAccepted
          }
        }))
        dispatch(DebinActions.confirmRecurrenceRejected())
      }
    }

export const cancelRecurrence =
  (recurrenceId: number) => async (dispatch: ThunkDispatchType) => {
    try {
      dispatch(DebinActions.cancelRecurrencePending())
      const response = await DebinServices.cancelRecurrence(recurrenceId)

      if (response.status !== 200) {
        throw response?.data.data
      }

      dispatch(
        showDrawer(Drawers.DEBIN_OPERATION_SUCCESS, {
          debinData: {
            isRefund: response.data.data.isRefund,
            operationType: OperationType.DEBIN_CANCELATION
          }
        })
      )

      dispatch(
        DebinActions.cancelRecurrenceFulfilled(response.data.data)
      )
      dispatch(getRecurrences())
    } catch (error) {
      dispatch(showDrawer(Drawers.DEBIN_OPERATION_ERROR, {
        debinData: {
          operationType: OperationType.DEBIN_CANCELATION
        }
      }))
      dispatch(DebinActions.cancelRecurrenceRejected())
    }
  }

export const getDebinMovements = () => async (dispatch: ThunkDispatchType) => {
  try {
    dispatch(DebinActions.getDebinMovementsPending())
    const response = await DebinServices.getDebinMovements()

    if (response.status !== 200) {
      throw response?.data.data
    }
    dispatch(DebinActions.getDebinMovementsFulfilled(response.data.data))
  } catch (error) {
    dispatch(DebinActions.cancelRecurrenceRejected())
  }
}
